import { FormHelperText } from 'material-ui/Form';
import React, { Component } from 'react';
import { Icon, Label, Popup, Message } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ReduxFormCommon.css';
const cx = classNames.bind(styles);

const GeneralHint = ({ visited, touched, dirty, error, warning }) => {
  let hint = null;
  const checkInfo = [];
  let count = 1;
  if ((dirty || touched) && visited) {
    if (error) {
      checkInfo.push(<p key={'error' + count++}>{error}</p>);
    }
    if (warning) {
      checkInfo.push(<p key={'warn' + count++}>{warning}</p>);
    }

    if (checkInfo.length > 0) {
      hint = (
        <Message className="normal-validate-hint-box" negative compact size="tiny">
          {checkInfo}
        </Message>
      );
    }
  }

  return hint;
};

const MaterialFormHelper = ({ visited, touched, dirty, error, warning }) => {
  let hint = null;
  let checkInfo = '';
  if ((dirty || touched) && visited) {
    if (error) {
      checkInfo = checkInfo + error;
    }
    if (warning) {
      checkInfo = checkInfo + ', ' + warning;
    }

    if (checkInfo !== '') {
      hint = (
        <FormHelperText className="material-form-helper-box" error>
          {checkInfo}
        </FormHelperText>
      );
    }
  }

  return hint;
};

const ReduxFormFieldCheckPopup = ({ ...rest }) => {
  const checkType = rest.checkType || 99;

  if (checkType === 100) {
    // not visible
    return null;
  } else if (checkType === 101) {
    // material FormHelperText
    return MaterialFormHelper({ ...rest });
  } else {
    // 기타 (범용)
    return GeneralHint({ ...rest });
  }
};

export default ReduxFormFieldCheckPopup;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormFieldCheckPopup.js